import { render, staticRenderFns } from "./workOrderTagModal.vue?vue&type=template&id=0fe5a571&scoped=true"
import script from "./workOrderTagModal.vue?vue&type=script&lang=js"
export * from "./workOrderTagModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe5a571",
  null
  
)

export default component.exports